export default __webpack_public_path__ + "static/media/p-11.85f27ca2.svg";